import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    initialize() {
        super.initialize();
    }

    updateQuery(event) {
        const name = event.target.name;
        const checked = event.target.checked;
        const urlSearchParams = new URLSearchParams(window.location.search);

        if (checked) {
            urlSearchParams.set(name, '1');
        } else {
            urlSearchParams.delete(name);
        }

        Turbo.visit(location.pathname + '?' + urlSearchParams);
    }
}
